module.exports = __webpack_public_path__ + "ai-bot-miniwp5e8c2ec44d0bfb576874535af32586d8.svg";